var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0108 3.60001C9.69121 3.60001 7.81081 5.48041 7.81081 7.80001C7.81081 10.1196 9.69121 12 12.0108 12C14.3304 12 16.2108 10.1196 16.2108 7.80001C16.2108 5.48041 14.3292 3.60001 12.0108 3.60001Z",
    fill: "#E4E4ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0132 12.9336H8.9868C7.4304 12.9336 6.0372 13.8984 5.4912 15.3564L4.782 17.2488C4.2108 18.7728 5.3376 20.4 6.966 20.4H17.0316C18.66 20.4 19.7892 18.7728 19.2168 17.2476L18.5076 15.3552C17.9616 13.8984 16.5684 12.9336 15.0132 12.9336Z",
    fill: "#C6C6D5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.42522d34f8189ad3cb794f2d9197dc9b.svg";
export { ForwardRef as ReactComponent };